import { useEffect, useMemo } from 'react';
import { when } from 'mobx';
import { observer } from 'mobx-react';
import { Smartlog } from '@fos/smartlog-desktop';

import { accessTokenStore } from './store/AccessTokenStore';
import { environmentStore } from './store/EnvironmentStore';
import { BackupErrorTypes, backupStore } from './store/BackupStore';
import { getGuidFromUrl } from './utils/GuidUtil';
import { ErrorScreen } from './components/error-screen';
import { LoadingScreen } from './components/loading-screen';
import { HttpClient } from './utils/HttpClient';

import './App.scss';

export const App = observer(() => {
  useEffect(() => {
    environmentStore.setVesselId(getGuidFromUrl(window.location.href));
    accessTokenStore.initialize();
    HttpClient.init();

    if (!environmentStore.vesselId) {
      return;
    }

    when(
      () => accessTokenStore.loaded,
      async () => {
        backupStore.initialize();
      }
    );
  }, []);

  const errorTitle = useMemo(() => {
    if (!environmentStore.vesselId) {
      return 'No vessel selected';
    }

    if (backupStore.initializeStatus === 'error') {
      switch (backupStore.errorType) {
        case BackupErrorTypes.permission_required:
          return 'No access to the application';
        case BackupErrorTypes.vessel_access_denied:
          return 'No access to the vessel';
        default:
          return 'Data initialization problems (We are working to resolve the issue....)';
      }
    }

    return null;
  }, [environmentStore.vesselId, backupStore.initializeStatus, backupStore.errorType]);

  if (!environmentStore.loaded || !accessTokenStore.loaded || backupStore.initializeStatus === 'loading') {
    return <LoadingScreen />;
  }

  if (errorTitle) {
    return <ErrorScreen title={errorTitle} />;
  }

  return (
    <Smartlog
      environment={environmentStore.environmentWithVesselId}
      token={accessTokenStore.tokens}
      settings={{
        isSendingLogAvailable: false,
        appLock: {
          lockAll: !accessTokenStore.hasGodRights,
        },
      }}
    />
  );
});
